var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFornecedor01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1536",
    d: "M4.2,27.8v-1.3c0-1.6,1.3-2.9,2.9-2.9h12.3c0.7,0,1.3,0.6,1.3,1.3c0,0.3-0.1,0.6-0.3,0.8l-0.3,0.2l0,0 c-0.2,0.1-0.5,0.2-0.7,0.2H13c-0.7,0-1.3,0.6-1.3,1.3c0,0.7,0.6,1.3,1.3,1.3h6.4c1.1,0,2.1-0.4,2.8-1.2l7.4-6.7l0,0 c0.5-0.5,1.3-0.5,1.8,0c0.5,0.5,0.5,1.3,0,1.8l0,0l-6.5,6l0,0C22,31.3,18,32.9,14,32.9h-11c-0.7,0-1.3,0.6-1.3,1.3s0.6,1.3,1.3,1.3 h11c4.7,0,9.3-1.8,12.7-5.1l6.5-6l0,0c1.5-1.5,1.5-3.9,0.1-5.4c-1.5-1.5-3.9-1.5-5.4-0.1l-4.9,4.5c-0.6-1.4-2-2.3-3.5-2.3H7.1 c-3,0-5.5,2.5-5.5,5.5v1.3c0,0.7,0.6,1.3,1.3,1.3S4.2,28.5,4.2,27.8L4.2,27.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Caminho_945_1_",
    d: "M26.1,4l-7.9-3.4c-0.1-0.1-0.3-0.1-0.4,0L9.9,4C9.7,4.1,9.6,4.3,9.6,4.5v9.8c0,0.2,0.1,0.4,0.3,0.4 l7.9,4c0.1,0,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1l7.9-4c0.2-0.1,0.3-0.3,0.3-0.4V4.5C26.4,4.3,26.3,4.1,26.1,4z M18,1.6l6.7,2.9 L18,7.4l-1.7-0.8l2.6-1.1c0.3-0.1,0.4-0.4,0.3-0.6c0-0.1-0.2-0.2-0.3-0.3l-2.1-0.9c-0.1-0.1-0.3-0.1-0.4,0l-3.5,1.5l-1.6-0.7L18,1.6 z M13.6,6.5l1,0.4v2.1l-1-0.5V6.5z M14.2,5.7l2.4-1.1L17.5,5L15,6.1L14.2,5.7z M10.6,5.2l2,0.9v2.8c0,0.2,0.1,0.4,0.3,0.4l2,1 c0.2,0.1,0.5,0,0.7-0.2c0-0.1,0.1-0.1,0.1-0.2V7.4l2,0.9v9.3L10.6,14L10.6,5.2z M18.5,17.5V8.2l6.9-3v8.8L18.5,17.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFornecedor01);
export default __webpack_public_path__ + "static/media/ico-fornecedor-01.54746bc53a1f02f6010f91d012a8ad39.svg";
export { ForwardRef as ReactComponent };